/** Per-project pull cursors (opaque strings owned by the server). */
import { db } from './db';

export async function getCursor(projectId: string): Promise<string | null> {
  return (await db.sync_cursors.get(projectId))?.cursor ?? null;
}

/** Call inside the same transaction that applies the page the cursor came with. */
export async function setCursor(projectId: string, cursor: string | null): Promise<void> {
  await db.sync_cursors.put({
    project_id: projectId,
    cursor,
    updated_at: new Date().toISOString(),
  });
}
